module.exports = "../images/ear-falls-golf-and-country-club.jpg?v=517fd98";